<template>
  <div>
     <el-row :gutter="20" style="margin-top: 15px;">
      <!-- 左侧表单 -->
      <el-col :span="14">
        <el-card>
          <el-row class="title_row">
            <el-col>
              <span class="title_class">合同信息录入</span>
            </el-col>
          </el-row>
          <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px">
            <el-row :gutter="14">
              <el-col :span="12">
                <el-form-item label="客户名称" prop="customerName">
                  <el-input v-model="form.customerName" placeholder="请输入客户名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同编号" prop="contractNo">
                  <el-input v-model="form.contractNo" placeholder="请输入合同编号"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="甲方" prop="partyA">
                  <el-input v-model="form.partyA" placeholder="请输入甲方名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="乙方" prop="partyB">
                  <el-input v-model="form.partyB" placeholder="请输入乙方名称"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同金额" prop="contractAmount">
                  <el-input v-model="form.contractAmount" placeholder="请输入合同金额/元" @blur="handleAmountBlur"></el-input>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
                <el-form-item label="项目类型">
                  <el-input :value="type" disabled style="width: 100%"></el-input>
                </el-form-item>
              </el-col> -->
              <el-col :span="12">
                <el-form-item label="金额大写：">
                  <div class="amount">
                    {{ amount }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签订日期" prop="signingDate">
                  <el-date-picker v-model="form.signingDate" type="date" placeholder="请选择签订日期" style="width: 100%" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收费日期" prop="paymentDate">
                  <el-date-picker v-model="form.paymentDate" type="date" placeholder="请选择收费日期" style="width: 100%" value-format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支付方式" prop="paymentMethodEnum">
                  <el-select v-model="form.paymentMethodEnum" style="width: 100%;">
                    <el-option
                      v-for="item in paymentMethodList"
                      :key="item.enumkey"
                      :label="item.desc"
                      :value="item.enumkey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="缴费类型" prop="paymentTypeEnum">
                  <el-select v-model="form.paymentTypeEnum" style="width: 100%;">
                    <el-option
                      v-for="item in paymentTypeList"
                      :key="item.enumkey"
                      :label="item.desc"
                      :value="item.enumkey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="缴费凭证" prop="paymentVoucher">
                  <el-upload
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="handleVoucherSuccess"
                    :on-remove="handleVoucherRemove"
                    :file-list="voucherList"
                    :data="{ filePath: 'spbcn/spbcnappneed/crm/paymentVoucher/' }"
                  >
                    <el-button size="small" type="primary" plain>点击上传</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传图片</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同附件" prop="contractAttachment">
                  <el-upload
                    :action="uploadUrl"
                    :headers="uploadHeaders"
                    :on-success="handleAttachmentSuccess"
                    :on-remove="handleAttachmentRemove"
                    :file-list="attachmentList"
                    :data="{ filePath: 'spbcn/spbcnappneed/crm/contractAttachment/' }"
                  >
                    <el-button size="small" type="primary" plain>点击上传</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">上传合同附件文件</div> -->
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合同状态" prop="contractStatusEnum">
                  <el-select v-model="form.contractStatusEnum" style="width: 100%;">
                    <el-option
                      v-for="item in contractStatusList"
                      :key="item.enumkey"
                      :label="item.desc"
                      :value="item.enumkey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="提交审批" prop="submitProcess">
                  <el-radio-group v-model="form.submitProcess">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="remark">
                  <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入备注信息"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="text-align: center;">
              <el-button type="primary" @click="onSubmit">提交</el-button>
              <el-button @click="onReset">重置</el-button>
            </div>
          </el-form>
        </el-card>
      </el-col>

      <!-- 右侧 -->
      <el-col :span="10">
        <!-- 合同列表 -->
        <el-card>
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">未审批合同</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="text" size="mini" style="color: #1f30c7;" @click="handleTolist(0)">更多 >></el-button>
            </el-col>
          </el-row>
          <el-empty v-if="!pendingContractList.length" :image-size="60"></el-empty>
          <el-table v-else :data="pendingContractList" v-loading="pendingLoading" style="width: 100%" size="small">
            <el-table-column prop="customerName" label="客户名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contractAmount" label="合同金额/元" align="center"></el-table-column>
            <el-table-column prop="contractStatusDesc" label="合同状态" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" effect="plain" :type="getStatusType(scope.row.contractStatusDesc)">{{ scope.row.contractStatusDesc }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="80" align="center">
              <template slot-scope="scope">
                <el-button type="text" style="color: #E6A23C;" size="small" @click="submitApproval(scope.row)">提交审批</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-card style="margin-top: 15px;">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">审批中合同</span>
            </el-col>
            <el-col :span="12" align="right">
              <el-button type="text" size="mini" style="color: #1f30c7;" @click="handleTolist(1)">更多 >></el-button>
            </el-col>
          </el-row>
          <el-empty v-if="!approvingContractList.length" :image-size="60"></el-empty>
          <el-table v-else :data="approvingContractList" v-loading="approvingLoading" style="width: 100%" size="small">
            <!-- <el-table-column prop="contractNo" label="合同编号" min-width="120"></el-table-column> -->
            <el-table-column prop="customerName" label="客户名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contractAmount" label="合同金额/元" align="center"></el-table-column>
            <el-table-column prop="contractStatusDesc" label="合同状态" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" effect="plain" :type="getStatusType(scope.row.contractStatusDesc)">{{ scope.row.contractStatusDesc }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="80" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="onView(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
        <el-row>
          <el-col :span="24" align="right">
            <el-button type="text" style="color: #1f30c7;margin-top: 20px;" @click="nextPage">查看全部合同>></el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 合同编辑弹窗 -->
    <ContractFormDialog
      :visible.sync="dialogVisible"
      :row="currentRow"
      type="preview"
    />
  </div>
</template>
<script>
import ContractFormDialog from './ContractFormDialog.vue'

export default {
  components: { ContractFormDialog },
  props: {
    projectType: {
      type: String
    }
  },
  data () {
    return {
      currentRow: {},
      dialogVisible: false,
      amount: '',
      form: {
        customerName: '',
        partyA: '',
        partyB: '',
        contractAmount: '',
        contractNo: '',
        contractStatusEnum: '',
        projectTypeEnum: '',
        signingDate: '',
        paymentDate: '',
        paymentMethodEnum: '',
        paymentTypeEnum: '',
        paymentVoucher: '',
        contractAttachment: '',
        submitProcess: false,
        remark: ''
      },
      formRules: {
        customerName: [{ required: true, message: '请输入', trigger: 'blur' }],
        partyA: [{ required: true, message: '请输入', trigger: 'blur' }],
        partyB: [{ required: true, message: '请输入', trigger: 'blur' }],
        contractAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        contractNo: [{ required: true, message: '请输入', trigger: 'blur' }],
        contractStatusEnum: [{ required: true, message: '请选择', trigger: 'change' }],
        signingDate: [{ required: true, message: '请选择', trigger: 'change' }],
        paymentDate: [{ required: true, message: '请选择', trigger: 'change' }],
        paymentMethodEnum: [{ required: true, message: '请选择', trigger: 'change' }],
        paymentTypeEnum: [{ required: true, message: '请选择', trigger: 'change' }],
        // paymentVoucher: [{ required: true, message: '请上传', trigger: 'change' }],
        // contractAttachment: [{ required: true, message: '请上传', trigger: 'change' }],
        submitProcess: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      // 未审批合同（flowStatus=0，接口获取）
      pendingContractList: [],
      pendingLoading: false,
      // 审批中合同（flowStatus=1，接口获取）
      approvingContractList: [],
      approvingLoading: false,
      contractStatusList: [],
      paymentMethodList: [],
      paymentTypeList: [],
      projectTypeList: [],
      uploadUrl: this.$http.defaults.baseURL + 'upload/uploadFileAliOss',
      uploadHeaders: { Authorization: localStorage.getItem('Authorization') },
      voucherList: [],
      attachmentList: []
    }
  },
  created () {
    this.getSelectList()
    this.refreshContractList()
  },
  methods: {
    getSelectList () {
      this.$http.get('contractPaymentInfo/enums').then(res => {
        if (res.code === 200) {
          this.contractStatusList = res.data.contractStatusList
          this.paymentMethodList = res.data.paymentMethodList
          this.paymentTypeList = res.data.paymentTypeList
          this.projectTypeList = res.data.projectTypeList
        }
      })
    },
    // 刷新左右两侧合同列表
    refreshContractList () {
      this.getPendingContractList()
      this.getApprovingContractList()
    },
    // 获取未审批合同列表（flowStatus=0）
    getPendingContractList () {
      this.pendingLoading = true
      const params = {
        pageNum: 1,
        pageSize: 3,
        flowStatus: 0,
        projectType: this.projectType
      }
      this.$http.get('contractPaymentInfo/page', { params }).then((res) => {
        if (res.code === 200) {
          this.pendingContractList = res.data.list || []
        } else {
          this.$message.error(res.msg || '获取未审批合同失败')
        }
        this.pendingLoading = false
      }).catch(() => {
        this.pendingLoading = false
      })
    },
    // 获取审批中合同列表（flowStatus=1）
    getApprovingContractList () {
      this.approvingLoading = true
      const params = {
        pageNum: 1,
        pageSize: 3,
        flowStatus: 1,
        projectType: this.projectType
      }
      this.$http.get('contractPaymentInfo/page', { params }).then((res) => {
        if (res.code === 200) {
          this.approvingContractList = res.data.list || []
        } else {
          this.$message.error(res.msg || '获取审批中合同失败')
        }
        this.approvingLoading = false
      }).catch(() => {
        this.approvingLoading = false
      })
    },
    // 合同金额失去焦点后，转换为金额汉字大写
    handleAmountBlur () {
      const value = String(this.form.contractAmount || '').replace(/,/g, '').trim()
      const num = Number(value)
      if (value === '' || isNaN(num)) {
        this.amount = ''
        return
      }
      this.amount = this.numberToChineseAmount(num)
    },
    // 数字金额转汉字大写（支持到万亿级，四舍五入保留到分）
    numberToChineseAmount (num) {
      if (num === 0) return '零元整'
      const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
      const units = ['', '拾', '佰', '仟']
      const bigUnits = ['', '万', '亿', '万亿']
      let result = num < 0 ? '负' : ''
      num = Math.round(Math.abs(num) * 100) / 100
      const integerPart = Math.floor(num)
      const decimalPart = Math.round((num - integerPart) * 100) // 角分（0-99）
      const jiao = Math.floor(decimalPart / 10)
      const fen = decimalPart % 10
      // 整数部分：每4位一组，从高位组到低位组
      if (integerPart > 0) {
        const sections = []
        let n = integerPart
        while (n > 0) {
          sections.push(n % 10000)
          n = Math.floor(n / 10000)
        }
        let intStr = ''
        for (let i = sections.length - 1; i >= 0; i--) {
          const section = sections[i]
          if (section === 0) {
            // 整组为0：若低位还有非零组，需要补一个零（如 1亿0001万 场景）
            if (i > 0 && sections.slice(0, i).some(s => s > 0) && !intStr.endsWith('零')) {
              intStr += '零'
            }
            continue
          }
          let sectionStr = ''
          for (let j = 3; j >= 0; j--) {
            const d = Math.floor(section / Math.pow(10, j)) % 10
            if (d === 0) {
              if (sectionStr !== '' && !sectionStr.endsWith('零')) sectionStr += '零'
            } else {
              sectionStr += digits[d] + units[j]
            }
          }
          sectionStr = sectionStr.replace(/零+$/, '')
          intStr += sectionStr + bigUnits[i]
          // 该组不足千位且低位还有非零组时补零（如 10001 → 壹万零壹）
          if (i > 0 && section < 1000 && sections.slice(0, i).some(s => s > 0) && !intStr.endsWith('零')) {
            intStr += '零'
          }
        }
        intStr = intStr.replace(/零+/g, '零').replace(/零$/, '')
        result += intStr + '元'
      }
      // 小数部分：角、分
      if (jiao === 0 && fen === 0) {
        if (integerPart > 0) result += '整'
      } else {
        if (jiao > 0) {
          result += digits[jiao] + '角'
        } else if (integerPart > 0) {
          result += '零' // 如 1.05 → 壹元零伍分
        }
        if (fen > 0) {
          result += digits[fen] + '分'
        }
      }
      return result
    },
    handleTolist (type) {
      this.$router.push(`/product_Management/contract_list?flowStatus=${type}&projectType=${this.projectType}`)
    },
    nextPage () {
      this.$router.push('/product_Management/contract_list?projectType=' + this.projectType)
    },
    getStatusType (status) {
      const map = {
        0: '',
        1: 'success',
        2: 'warning',
        3: 'success',
        4: 'danger',
        草稿: '',
        已签订: 'success',
        执行中: 'warning',
        已完成: 'success',
        已终止: 'danger'
      }
      return map[status] || ''
    },
    onSubmit () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        const params = {
          ...this.form,
          projectTypeEnum: this.projectType
        }
        this.$http.post('contractPaymentInfo/add', params).then((res) => {
          if (res.code === 200) {
            this.$message.success('提交成功')
            this.onReset()
            // 刷新合同列表
            this.refreshContractList()
          }
        })
      })
    },
    // 提交审批
    submitApproval (row) {
      if (!row.id) {
        this.$message.warning('缺少合同ID，无法提交审批')
        return
      }
      this.$confirm('确认提交该合同进入审批流程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('contractPaymentInfo/submit/' + row.id).then((res) => {
          if (res.code === 200) {
            this.$message.success('提交审批成功')
            // 提交成功后刷新合同列表
            this.refreshContractList()
          }
        })
      }).catch(() => {})
    },
    handleVoucherSuccess (res) {
      if (res.code === 200 && res.data) {
        this.form.paymentVoucher = res.data
      }
    },
    handleVoucherRemove () {
      this.form.paymentVoucher = ''
    },
    handleAttachmentSuccess (res) {
      if (res.code === 200 && res.data) {
        this.form.contractAttachment = res.data
      }
    },
    handleAttachmentRemove () {
      this.form.contractAttachment = ''
    },
    onReset () {
      this.$refs.formRef.resetFields()
      this.voucherList = []
      this.attachmentList = []
      this.form.paymentVoucher = ''
      this.form.contractAttachment = ''
      this.amount = ''
    },
    onView (row) {
      this.currentRow = row
      this.dialogVisible = true
    }
  }
}
</script>
<style lang="less" scoped>
.amount{
  font-size: 16px;
  font-weight: bold;
  color: #000;
}
</style>
